import { Box } from '@chakra-ui/react'
import * as T from '../../../../../../components/Table'

export const Item = ({
  selectedItem,
  setSelectedItem,
  item,
  striped,
  control,
  name,
}) => {
  return (
    <T.Tr
      cursor="pointer"
      onClick={() => {
        setSelectedItem(item)
      }}
      {...(striped &&
        !selectedItem && {
          bg: 'gray.50',
        })}
      {...(selectedItem && {
        bg: 'blue.500',
      })}
    >
      <T.Td
        py={2}
        onClick={() => {
          setSelectedItem(item)
        }}
        {...(selectedItem && {
          bg: 'blue.500',
        })}
      >
        <Box
          mx="auto"
          w="4"
          h="4"
          bg="transparent"
          border="1px solid"
          borderColor="gray.300"
          borderRadius="50%"
          {...(selectedItem && {
            bg: 'white',
            p: 1,
            color: 'white',
          })}
        />
      </T.Td>
      <T.Td
        {...(selectedItem && {
          bg: 'blue.500',
          color: 'white',
        })}
        py={2}
      >
        {item.id_venda}
      </T.Td>
      <T.Td
        {...(selectedItem && {
          bg: 'blue.500',
          color: 'white',
        })}
        py={2}
        textAlign="start"
      >
        {item.tipo_pagamento}
      </T.Td>
    </T.Tr>
  )
}
